<template>
  <div class="VaerelseEllerParkering">
    <!-- <a href="javascript:history.back()" class="arrow arrow-left"></a> -->

    <h1>{{ $t('hvadoenskerduatbestille') }}</h1>
    <!-- <p>Koncern: {{ this.$route.params.koncern }}</p> -->
    <!-- <p>Locale: {{ this.locale }}</p> -->
    <div class="Valg">
      <div>{{ $t('ankomsttid') }}</div>
      <div>{{ $t('afrejsetid') }}</div>
      <ul class="flex-container">
        <li v-if="valgtHotel.vaerelser > 0" class="flex-item"><router-link :to="{ path: '/'+this.locale+'/'+this.$route.params.koncern+'/hotel/'+this.$route.params.postnr+'/startdato'}" class="hotelButton" @click.native="saveChoice('roomtype', 'vaerelse')">{{ $t('vaerelse') }}</router-link></li>
        <li v-if="valgtHotel.parkering > 0" class="flex-item"><router-link :to="{ path: '/'+this.locale+'/'+this.$route.params.koncern+'/hotel/'+this.$route.params.postnr+'/startdato'}" class="hotelButton" @click.native="saveChoice('roomtype', 'parkering')">{{ $t('parkering') }}</router-link></li>
        <li v-if="valgtHotel.moedelokale > 0" class="flex-item"><router-link :to="{ path: '/'+this.locale+'/'+this.$route.params.koncern+'/hotel/'+this.$route.params.postnr+'/startdato'}" class="hotelButton" @click.native="saveChoice('roomtype', 'moedelokale')">{{ $t('C') }}</router-link></li>
        <li v-if="valgtHotel.selvstaendig > 0" class="flex-item"><router-link :to="{ path: '/'+this.locale+'/'+this.$route.params.koncern+'/hotel/'+this.$route.params.postnr+'/startdato'}" class="hotelButton" @click.native="saveChoice('roomtype', 'ekstra')">Ekstra tilkøb</router-link></li>
        <li v-if="valgtHotel.selskabslokale > 0" class="flex-item"><router-link :to="{ path: '/'+this.locale+'/'+this.$route.params.koncern+'/hotel/'+this.$route.params.postnr+'/startdato'}" class="hotelButton" @click.native="saveChoice('roomtype', 'selskabslokale')">{{ $t('S') }}</router-link></li>
      </ul>
    </div>

<!--     <div class="continueButton">
      <a href="#">Tilbage</a>
    </div> -->

  <a href="" v-on:click="navigateBack()">
    <div class="tilbage">
        <p>&#171; {{ $t('tilbagetekst') }}</p>
    </div>
  </a>


  </div>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
  name: 'App',
  data () {
    return {
      locale: i18n.locale,
      postnr: -1,
      valgtHotel: {},
      bookingData: {
        "postnr": this.postnr, 
        "roomType": -1
      },
    }
  },
  components: {
    //VaerelseEllerParkering
  },
  created() {
    this.postnr = this.$route.params.postnr;
    this.getHotelData(this.$route.params.koncern);
    var value = this.postnr;
    var name = 'hotel';
    this.$store.dispatch("addToCart", { name, value });   // Gem valgt postnr i Vuex store
    this.saveChoice('roomtype', '');
  },
  methods: {
    getHotelData(koncern) {
      if(this.$store.getters.hotels.length == null) {
        console.log('Hotels er ikke loaded... Henter dem nu...');
        this.$store.dispatch('getHotelData', {koncern}).then(() => {
          this.findHotel(this.postnr);
        });
      } else {
        this.findHotel(this.postnr);
      }
    },
    // Hent data for det valgte hotel fra vuex store
    findHotel(postnr) {
      console.log('Finder data for hotel i postnr: '+this.postnr);
      for (var i=0; i< this.$store.getters.hotels.length; i++) {
        if(this.$store.getters.hotels[i].postnr == postnr) {
          this.valgtHotel = this.$store.getters.hotels[i];
        }
      }
    },
    // Gemmer de booking-valg der er foretaget
    saveChoice(name, value) {
      this.$store.dispatch("addToCart", { name, value })
      // Hvis der er valgt 'ekstra tilkøb' så send brugeren direkte til ekstra tilkøb
      if(value === 'ekstra') {
        //this.$router.replace({ name: "6-ekstra" });
      }
    },
    navigateBack() {
      var path = '/'+this.locale+'/'+this.$route.params.koncern;
      this.$router.push({ path: path });
    },


  },

}
</script>

<style scoped>

h1 {
  font-size: 400%;
  margin-bottom: 120px;
}

a {
  text-decoration: none;
  color: black;
}

.tilbage {
    margin-top: 50px;
    text-transform: none;
}

.flex-container {
  padding: 0;
  list-style: none;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction:row;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;
  width: 100%;
  
}

.flex-item {
  margin-left: 10px;
  margin-right: 10px;
  width: 90%;
  max-width: 330px;
  height: 150px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.continueButton {
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 230px;
  height: 80px;  
  font-size: 150%;
  letter-spacing: 1px;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: auto;
  margin-right: auto;
}

@media screen and (max-width: 959px) {
    /* Mindre overskrift */
    h1 {
        font-size: 200%;
        margin-bottom: 40px;
    }
}

/* CSS specific to iOS devices */ 
@supports (-webkit-touch-callout: none) {
  .flex-container {
    
    margin-right: 10px;
    margin-left: 20px;
    padding-left: 0px;
    padding-right: 0px;
  }

}

</style>
